// Module
var code = "<template> <require from=\"./your-dashboard.scss\"></require> <page name=\"your-dashboard\" busy.bind=\"true\"> </page> </template> ";
// Exports
module.exports = code;